export enum ObstructionReportsRelations {
  trail = 'trails',
}
